// #region imports

import React from 'react';

// Material-UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';

// Styles
import { useTheme } from '@mui/material/styles';

// #endregion

const MealsHeader: React.FC = () => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      margin: theme.spacing(1, 1, 1, 1),
    }
  };

  // #endregion

  return (
    <Box sx={styles.root}>
      <Grid container sx={styles.root}>
        <Grid container>
          <Typography variant="body2">Nightly counts of individuals staying at the lodge for meals and grocery purchases (CONFIRMED lodge use requests only).</Typography>
          <Typography variant="body2" component="div" gutterBottom>
            <ul>
              <li>All exceptions should be added to lodge use request notes before the cancellation deadline</li>
              <li>Individuals not staying at the lodge should submit a meal request to signups@montclairskiclub.com before the cancellation deadline</li>
            </ul>
          </Typography>
        </Grid>
        <Grid container>
          <Typography variant="caption">*No meal charge for children under age 12</Typography>
        </Grid>
      </Grid>
    </Box>
  );

}

export default MealsHeader;